const live = "https://api.fooddy.ng/api/v1/";
export const BASE_URL = process.env.REACT_APP_BASE_URL || live;
